export const AppInfo = {
  companyName: 'Urbanate',
  url: 'urbanate.com',
  privacyPolicy: 'https://urbanate.com/privacy-policy',
  termsOfService: 'https://urbanate.com/terms',
};
